import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgSelectComponent } from './select.component';
import { HighlightPipe } from './select-pipes';
import { OffClickDirective } from './off-click';
import { TooltipDirectiveModule } from '../../../../directives/tooltip/tooltip.directive.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TooltipDirectiveModule, TranslateModule],
  declarations: [NgSelectComponent, HighlightPipe, OffClickDirective],
  exports: [NgSelectComponent, HighlightPipe, OffClickDirective, TooltipDirectiveModule]
})
export class NgSelectModule {
}



// WEBPACK FOOTER //
// ./src/app/components/form/select/ng-select/select.module.ts